export const JOBSITES_CONSTANTS = {
    MODULE_NAME:'Job Sites',
    JOBSITE_NAME_LABEL: 'Job Site Name*' ,
    JOB_SITE_HDR: "Job Site",
    UPDATE_MSG: "Job Site updated.",
    NEW_JOBSITE_ADDED_MSG: "Job site added.",
    NO_DATA_INFO: "No Job site found.",
    DELETE_MSG: "Are you sure you want to delete the Job site?"
}